export const AuthorizationErrorMaintainerEnphaseTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-25 rounded text-gray-700">
        <h4 className="font-semibold">
            For Enphase Systems using the Authorized Subcontractor Method to Share Monitoring Data
        </h4>
        <p className="my-4">
            Your company has chosen to share monitoring data for all enrolled warranties using the
            Authorized Subcontractor method in Enlighten. For this method, you need to individually set up
            data access for every individual system that is enrolled on the Daybreak platform. An
            authorization error most likely indicates that you have not yet set up access permissions to
            share monitoring data with Solar Insure. This system needs to be accessible in Solar
            Insure's Enlighten Maintainer Account to show up in Daybreak. Follow these steps to resolve
            the issue:
        </p>
        <h5 className="font-semibold">Step One: Verify Manufacturer System ID</h5>
        <ul className="mt-4 list-decimal pl-5">
            <li>Navigate to the "Warranty Holder Details - Warranty Tab".</li>
            <li>
                Click on the "Edit Warranty" option to access and modify the warranty enrollment details.
            </li>
            <li>
                Carefully verify that the Manufacturer System Identifier entered is correct. Cross-reference
                this ID with the site listed in the Enphase Enlighten Portal to ensure accuracy.
            </li>
            <li>If the system ID does not match, update the ID and save the changes.</li>
        </ul>
        <h5 className="font-semibold mt-4">Step Two: Set Up Authorized Subcontractor Access</h5>
        <h6 className="my-4">
            If the System is New and Has Not Yet Been Activated in the Enlighten Portal:
        </h6>
        <ul className="mt-4 list-decimal pl-5">
            <li>Log into the Enphase Enlighten Portal.</li>
            <li>
                Locate and select the specific system that is experiencing the error to view its details.
            </li>
            <li>Go to the 'Settings' page for that system by clicking on the gear icon.</li>
            <li>
                Review the Activation checklist. If Step 4 is still not complete, add Solar Insure as an
                Authorized Subcontractor.
            </li>
            <li>
                Return to the Daybreak platform. Click on the refresh monitoring button to initiate a new
                attempt to pull monitoring data.
            </li>
        </ul>
        <h6 className="my-4">If the System Has Already Been Activated:</h6>
        <ul className="mt-4 list-decimal pl-5">
            <li>Log into the Enphase Enlighten Portal.</li>
            <li>
                Locate and select the specific system that is experiencing the error to view its details.
            </li>
            <li>Go to the 'Settings' page for that system by clicking on the gear icon.</li>
            <li>Scroll down to the System Access section.</li>
            <li>
                In the 'Companies with Access' section, add the email monitoring@solarinsure.com
                in the Email Address input field. Select that email address as an authorized subcontractor
                and hit save.
            </li>
            <li>
                Return to the Daybreak platform. Click on the refresh monitoring button to initiate a new
                attempt to pull monitoring data.
            </li>
        </ul>
    </div>
